module.exports = "/assets/2b44fc3ae1c5ff71c273eb2ddd8ab672.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/GE.png
// module id = 1402
// module chunks = 0